<template>
    <div class="flex flex-wrap gap-4 mt-2">
        <!-- Show items -->
        <div
            v-for="item in items"
            :key="item.id"
            class="relative w-24 h-24 rounded-md border-2 border-gray-200"
        >
            <button
                type="button"
                class="absolute z-10 -top-2 -right-2 bg-red-500 text-white p-0.5 leading-none rounded-full"
                @click="removeItem(item)"
            >
                <XIcon class="w-4 h-4" />
            </button>

            <a
                :href="item.path"
                target="_blank"
                class="relative block w-full h-full overflow-hidden rounded-md hover:opacity-75"
            >
                <img
                    :src="item.path"
                    :alt="item.name"
                    class="object-center object-cover"
                />
            </a>
        </div>

        <!-- Dropzone for new items -->
        <div
            class="relative w-24 h-24 rounded-md border-2 border-dashed border-gray-200"
            v-if="multiple || ! modelValue"
        >
            <input
                type="file"
                id="fileUpload"
                class="absolute inset-0 z-50 m-0 p-0 w-full h-full outline-none opacity-0 cursor-pointer"
                v-on:dragover="adding = true"
                v-on:dragleave="adding = false"
                v-on:drop="adding = false"
                ref="file"
                @input="handleFileUpload"
            >

            <label for="fileUpload">
                <div
                    class="w-full h-full flex justify-center items-center"
                    :class="{ 'bg-gray-100' : adding }"
                >
                    <svg v-if="uploading" class="animate-spin mx-auto h-12 w-12 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <svg v-else class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                        <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </label>
        </div>

    </div>
</template>

<script>
import {XIcon} from "@heroicons/vue/solid";
import Button from "@/Components/Button";
import axios from "axios";

export default {
    components: {
        Button,
        XIcon,
    },
    props: {
        modelValue: {
            type: [String, Number, Array, null],
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            items: [],
            adding: false,
            uploading: false,
        };
    },
    mounted() {
        this.loadItems();
    },
    methods: {
        loadItems() {
            let itemIds = this.multiple ? this.modelValue : [this.modelValue];

            if (! itemIds.length) {
                return;
            }

            axios
                .get(this.$route('admin::files.index', { ids: itemIds.join(',') }))
                .then((res) => {
                    this.items = res.data;
                });
        },
        handleFileUpload(event) {
            this.uploading = true;
            let file = event.target.files[0];

            let request = new FormData();
            request.append('file', file);

            axios
                .post(this.$route('admin::files.store'), request, {
                    header: {
                        'Content-Type': 'multipart/form-data'
                    },
                })
                .then((res) => {
                    this.uploading = false;
                    this.addItem(res.data);
                });
        },
        addItem(item) {
            this.items.push(item);
            let modelValue = this.modelValue;

            if (this.multiple) {
                modelValue.push(item.id);
            }
            else {
                modelValue = item.id;
            }

            this.$emit('update:modelValue', modelValue);
        },
        removeItem(item) {
            this.items = this.items.filter((x) => x.id !== item.id);
            let modelValue = this.multiple
                ? this.modelValue.filter((x) => parseInt(x) !== parseInt(item.id))
                : null;

            this.$emit('update:modelValue', modelValue);
        },
    },
}
</script>
